import { Injectable, inject } from '@angular/core';
import { RbacService } from './rbac.service';
import { AuthenticationService } from './authentication.service';

/**
 * Starts background work once the root component has rendered, without blocking bootstrap.
 *
 * Wired through APP_BOOTSTRAP_LISTENER (see AppModule) instead of APP_INITIALIZER, so the app shell
 * renders first and permissions load in the background. Routed views stay protected by AuthGuard,
 * which waits on the same in-flight RbacService.loadPermissions() promise before activating a route.
 */
@Injectable({ providedIn: 'root' })
export class AppStartupService {
  private readonly rbacService = inject(RbacService);
  private readonly authService = inject(AuthenticationService);

  /**
   * Preloads user permissions in the background when the user already has an access token.
   * Fire-and-forget: failures are logged and left to the route guard to handle at navigation time.
   */
  preloadPermissions(): void {
    if (!this.authService.checkAuthentication()) {
      return;
    }

    this.rbacService.loadPermissions().catch((error) => {
      console.error('[AppStartup] Failed to preload permissions:', error);
    });
  }
}
